import React from "react";

type ConfirmDeleteContentProps = {
  children?: React.ReactNode;
  question?: string;
};

export function ConfirmDeleteContent({
  children,
  question = "¿Deseas eliminarlo?",
}: Readonly<ConfirmDeleteContentProps>) {
  return (
    <div className="flex flex-col gap-1">
      <p className="max-w-[315px] font-normal">{children}</p>
      <p className="font-bold">{question}</p>
    </div>
  );
}
